var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7718 1.66699C6.17178 1.66699 2.44678 5.40033 2.44678 10.0003C2.44678 14.6003 6.17178 18.3337 10.7718 18.3337C15.3801 18.3337 19.1134 14.6003 19.1134 10.0003C19.1134 5.40033 15.3801 1.66699 10.7718 1.66699ZM14.1134 13.3337C14.0363 13.4109 13.9448 13.4722 13.844 13.514C13.7432 13.5558 13.6351 13.5774 13.5259 13.5774C13.4168 13.5774 13.3087 13.5558 13.2079 13.514C13.1071 13.4722 13.0155 13.4109 12.9384 13.3337L10.1968 10.592C10.118 10.5148 10.0554 10.4228 10.0125 10.3212C9.96957 10.2197 9.94724 10.1106 9.94678 10.0003V6.66699C9.94678 6.20866 10.3218 5.83366 10.7801 5.83366C11.2384 5.83366 11.6134 6.20866 11.6134 6.66699V9.65866L14.1134 12.1587C14.4384 12.4837 14.4384 13.0087 14.1134 13.3337Z",
    fill: "#53B175"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.46ce1a869e3ae753789c6296c9ff2817.svg";
export { ForwardRef as ReactComponent };